module.exports = __webpack_public_path__ + "img/853-c14382.png";